module.exports = __webpack_public_path__ + "static/stepper-gold-icon-9151896d72a01f48f1dcf2e7d1f74d44.svg";